var alignItemValuesMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    baseline: "baseline",
    stretch: "stretch",
};
export default (function (_a) {
    var alignItems = _a.alignItems;
    return alignItems in alignItemValuesMap ? "align-items: ".concat(alignItemValuesMap[alignItems], ";") : "";
});
